import { Tile, TilesPosition } from '@thro-types/users';

export enum DrawerMode {
  CREATE = 'CREATE',
  PREDEFINED = 'PREDEFINED',
  DEFAULTICONS = 'DEFAULTICONS'
}

/* --- STATE --- */
export interface TileDrawerState {
  open: boolean;
  tile: Tile | undefined;
  currentMode: DrawerMode;
  selectedTilesToAdd: Tile[];
  customTilesToDelete: Tile[];
}

export interface LayoutState {
  tilesPositions: TilesPosition[];
}
